/* eslint-disable */
import { produce } from "immer";
import {
  INVESTOR_ID_FETCH_START,
  INVESTOR_ID_FETCH_SUCCESS,
  INVESTOR_ID_FETCH_FAILURE,
} from "../actions/types";

const investor = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case INVESTOR_ID_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case INVESTOR_ID_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case INVESTOR_ID_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default investor;
